module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Peru_Chimbote_Tank_2016-10-13_1.ee2b44f0.jpg";